import { useEffect, useRef, useState } from "react";
import useAuth from "../../../components/hooks/useAuth";
import useConfirm from "../../../components/hooks/useConfirm";
import SignatureCanvas from 'react-signature-canvas';
import { branchTimezone } from "../../../utils/summaryCalculation";
import { getCustomersExtraInformationsByCustomerId } from "../../../services/customerExtraInformation";
import axois from "../../../configs/axois";
import baseURL from "../../../configs/api";
import axios from "axios";
import { delete_fileUpload } from "../../../services/appFileUpload";
import { useTheme } from "../../../components/hooks/useTheme";
import { Button, Divider } from "@mui/material";
import { iconValues } from "../../../utils/iconValues";
import colorConfigs from "../../../configs/colorConfigs";
import { CurrentType } from "../../../enum/CurrentType";
import { put_Quote } from "../../../services/quotes";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";
import { confirmBooking } from "../../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

type ExtraInformation = {
  id: number;
  idNumber: string;
  issueDate: string;
  exprationDate: string;
  filePath: string;
  idTypeId: string;
  customerId: number;
  type: string;
};

type ConfirmProps = {
  goToNextPage: (page: number) => void;
  vehicleClassId: number;
  branchId: number;
  formattedCreatedAt: string;
  pickupDate: string;
  pickupTime: string;
  returnDate: string;
  returnTime: string;
  pickupLocation: number;
  returnLocation: number;
  locations: any[];
  customerId: number;
  localAddress: string;
  walkInCustomer: boolean;
  confirmSignatureURL: any;
  setConfirmSignatureURL: (value: any) => void;
  currentPage: string;
  reservationId: number;
  setPrimaryKey: (id: number) => void;
  checkExtraValue: any[];
  selectedVehicleClass: any;
  securityDepositAmount: number;
  wasSecurityDepositManuallyChanged: boolean;
  appliedDiscountList: any[];
  isCompletedOrCancelled: boolean;
  customerData: any | null;
  currentType: CurrentType;
  quoteId?: string | number;
  quotedata: any;
  summaryData: any;
  manualRateChange: any;
  refreshTheSummary: () => void;
  setPleaseWait: (value: boolean) => void;
};

export const Confirm = ({
  goToNextPage,
  vehicleClassId,
  branchId,
  formattedCreatedAt,
  pickupDate,
  pickupTime,
  returnDate,
  returnTime,
  pickupLocation,
  returnLocation,
  locations,
  customerId,
  localAddress,
  walkInCustomer,
  confirmSignatureURL,
  setConfirmSignatureURL,
  currentPage,
  reservationId,
  setPrimaryKey,
  checkExtraValue,
  selectedVehicleClass,
  securityDepositAmount,
  wasSecurityDepositManuallyChanged,
  appliedDiscountList,
  isCompletedOrCancelled,
  customerData,
  currentType,
  quoteId,
  quotedata,
  summaryData,
  manualRateChange,
  refreshTheSummary,
  setPleaseWait
}: ConfirmProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { dateFormat }: any = useGeneral();
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
  const [type, setType] = useState<any[]>([]);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [Street, setStreet] = useState<string>("");
  const [street2, setStreet2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [birthday, setBirthday] = useState("");

  let signaturePadRef = useRef<SignatureCanvas>(null);

  const [pickupLocationName, setPickupLocationName] = useState<string>("");
  const [returnLocationName, setReturnLocationName] = useState<string>("");

  let latestPickup = new Date();
  let latestReturn = new Date();
  if (pickupDate) latestPickup = new Date(pickupTime ? `${pickupDate}T${pickupTime}` : pickupDate);
  if (returnDate) latestReturn = new Date(returnTime ? `${returnDate}T${returnTime}` : returnDate);

  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  useEffect(() => {
    if (locations?.length > 0) setPickupLocationName(locations?.find((item: any) => item.id === pickupLocation)?.locationName);
  }, [locations, pickupLocation])

  useEffect(() => {
    if (locations?.length > 0) setReturnLocationName(locations?.find((item: any) => item.id === returnLocation)?.locationName);
  }, [locations, returnLocation])

  useEffect(() => {
    if (customerData) {
      setFirstName(customerData?.firstName);
      setLastName(customerData?.lastName);
      setEmailAddress(customerData?.emailAddress);
      setPhoneNumber(customerData?.phoneNumber);
      setStreet(customerData?.street);
      setStreet2(customerData?.street2);
      setCity(customerData?.city);
      setState(customerData?.state);
      setCountry(customerData?.country);
      setZip(customerData?.zip);
      setBirthday(
        moment(new Date(customerData?.birthday)).format(dateFormat)
      );
    } else {
      setFirstName("");
      setLastName("");
      setEmailAddress("");
      setPhoneNumber("");
      setStreet("");
      setStreet2("");
      setCity("");
      setState("");
      setCountry("");
      setZip("");
      setBirthday("");
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData]);

  useEffect(() => {
    if (currentPage === 'Confirm') {
      getCustomersExtraInformationsByCustomerId(customerId, tenantId)
        .then((response) => {
          setExtraRow(() =>
            response?.filter((value: any) => value.idTypeId !== 0)
              ?.map((item: ExtraInformation, index: number) => {
                return {
                  id: index + 1,
                  idNumber: item.idNumber,
                  issueDate: moment(new Date(item.issueDate)).format("YYYY-MM-DD"),
                  exprationDate: moment(new Date(item.exprationDate)).format("YYYY-MM-DD"),
                  filePath: item.filePath,
                  idTypeId: item.idTypeId,
                  customerId: item.customerId,
                  type: item.id,
                };
              })
          );

          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, currentPage]);

  useEffect(() => {
    axois
      .get(`${baseURL}IdType`, {
        headers: {
          'X-Tenant-ID': tenantId,
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setType(() => response.data);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const converTheBase64IntoFileAndUploadToServer = (canvas: HTMLCanvasElement, callback: any) => {
    if (!isCompletedOrCancelled) {
      canvas.toBlob((blob) => {
        if (blob) {
          const formData = new FormData();
          formData.append("ImageFile", blob, 'signature.png');
          axios
            .post(`${baseURL}reservationFile/upload`, formData, {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "multipart/form-data"
              },
              withCredentials: true,
            })
            .then((response) => {
              callback(response.data);
              handleTenantError(null);
            })
            .catch((error) => {
              setPleaseWait(false);
              handleTenantError(error);
              callback("");
            });
        } else {
          setPleaseWait(false);
          console.error("Error: Blob is null");
          callback("");
        }
      }, 'image/png');
    }
  }

  const saveProcessCompleted = (currentPrimaryKey: number) => {
    setPrimaryKey(currentPrimaryKey);
    goToNextPage(5);
    refreshTheSummary();
  }

  const uploadSignature = (canvas: HTMLCanvasElement): Promise<any> => {
    return new Promise((resolve, _) => {
      converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
        if (imageFilePath) {
          resolve({
            attributeName: "Reservation",
            fileName: imageFilePath,
            tabName: "Confirm",
            userId: auth?.id ?? 0,
            createdDate: new Date(UpdateTimezone)?.toLocaleString()
          });
        } else {
          resolve(null);
        }
      });
    });
  };

  const confirmTheReservation = async (confrimStatus: string) => {
    if (!isCompletedOrCancelled) {
      let hasInvalidDate = false;

      if (extraRow?.length !== 0) {
        await extraRow?.forEach(async (item: ExtraInformation) => {
          const returnDateTime = new Date(`${returnDate}T${returnTime}`);
          const exprationDate = new Date(item?.exprationDate);

          if (exprationDate < returnDateTime) {
            setConfirmData({
              title: 'Warning',
              summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the return date and time.`,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              }
            });

            setConfirmPopup(true);

            hasInvalidDate = true;
            return;
          }
        })
      }

      if (hasInvalidDate) return;

      if (selectedVehicleClass?.availableVehicles <= 0) {
        setConfirmData({
          title: 'Warning',
          summary: "Vehilce Class is Not Available",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
        return;
      }

      setPleaseWait(true);

      let additionalValue: any[] = [];
      if (checkExtraValue?.length > 0) {
        await checkExtraValue?.forEach((item: any,) => {
          additionalValue = [...additionalValue, ...item?.additionalCharges];
        });
      }

      let files: any[] = [];

      const canvas = signaturePadRef.current?.getTrimmedCanvas();

      if (canvas && (canvas.width > 1 && canvas.height > 1)) {
        const file = await uploadSignature(canvas);
        if (file) {
          files.push(file);
        }
      }

      confirmBooking(
        {
          pickupDate: pickupDate + "T" + pickupTime,
          returnDate: returnDate + "T" + returnTime,
          branchId: branchId,
          pickupLocationId: pickupLocation,
          returnLocationId: returnLocation,
          isWalkInCustomer: walkInCustomer,
          vehicleClassId: vehicleClassId,
          wasSecurityDepositManuallyChanged: wasSecurityDepositManuallyChanged,
          securityDepositAmount: securityDepositAmount,
          reservationAdditionalChargeDto: additionalValue?.map((item: any) => (
            {
              additionalChargeByBranchId: item?.additionalChargeBranchId,
              quantity: item?.quantity,
              basePrice: item?.basePrice
            }
          )),
          reservationDiscountDto: appliedDiscountList
            ?.filter((item: any) => item?.discountApplied)
            ?.map(item => (
              {
                discountId: item?.discountId,
                discountDefinition: item?.discountDefinition,
                discountType: item?.discountType,
                discountAmount: item?.discountAmount,
                discount: item?.discount,
                manualDiscount: item?.manualDiscount
              }
            )),
          mandatoryAdditionalChargesAmount: summaryData?.mandatoryAdditionalChargesAmount ?? 0,
          locationFeePercentage: summaryData?.locationFeePercentage ?? 0,
          taxPercentage: summaryData?.taxPercentage ?? 0,
          governmentTaxPercentage: summaryData?.governmentTaxPercentage ?? 0,
          customerId: customerId,
          localAddress: localAddress,
          fileUploadDataDto: files,
          ...manualRateChange
        },
        confrimStatus,
        auth?.id,
        tenantId
      )
        .then((data) => {
          saveProcessCompleted(data);
          signaturePadRef.current?.clear();

          if (currentType === CurrentType.ADD_FROM_QUOTES && quoteId && Number(quoteId) > 0) {
            updateQuote(data);
          }
          handleTenantError(null);
        })
        .catch((error) => {
          setConfirmData({
            title: 'Warning',
            summary: error.response.data,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);

          setPleaseWait(false);
          handleTenantError(error);
        });
    }
  }

  const updateQuote = async (reservationId: string) => {
    if (Number(reservationId) > 0 && quoteId && Number(quoteId) > 0) {
      await put_Quote({
        ...quotedata,
        status: "Completed",
        reservationId
      }, auth?.id, tenantId)
        .then(() => {
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWait(false);
          handleTenantError(error);
        });
    }
  }

  const deleteTheSignatureURL = async () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Delete Signature',
        summary: "Are you sure you want to delete this Signature?",
        confirmBtn: 'Yes',
        isConfirm: (callback: any) => {
          if (confirmSignatureURL?.id === 0) {
            setConfirmSignatureURL(null);
          } else {
            setPleaseWait(true);

            delete_fileUpload(confirmSignatureURL?.id, auth?.id, tenantId)
              .then(() => {
                setPleaseWait(false);
                setConfirmSignatureURL(null);
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWait(false);
                handleTenantError(error);
              });
          }
          callback();
        }
      });

      setConfirmPopup(true);
    }
  };


  return (
    <>
      <div className="w-full">
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Date & Time
        </span>
        <Divider className={`w-full ${themeStyles.divider.bg}`} />
        <div className="w-full my-2">
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Date</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{moment(latestPickup)?.format(dateFormat)}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Date</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{moment(latestReturn)?.format(dateFormat)}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Location</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{pickupLocationName}</span>
              </div>

            </div>
            <div className="space-y-4">
              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Time</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{moment(new Date(latestPickup)).format("hh:mm a")}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Time</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{moment(new Date(latestReturn)).format("hh:mm a")}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Location</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{returnLocationName}</span>
              </div>
            </div>

          </div>
        </div>
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Selected Vehicle
        </span>
        <Divider className={`w-full ${themeStyles.divider.bg}`} />
        <div className={`flex justify-between bg-transparent p-2 my-2 w-full h-full min-h-max rounded-lg shadow-sm border ${themeStyles.main.borderColor}`}>
          {/* Image */}
          <img
            src={
              selectedVehicleClass?.imagePath?.startsWith("data:image/png;base64,")
                ? selectedVehicleClass?.imagePath
                : `${baseURL}vehicleClassFile/Get?name=` + selectedVehicleClass?.imagePath
            }
            alt="vehicle"
            className="w-[230px] rounded-md"
          />

          {/* Info */}
          <div className="flex flex-col px-2 w-[34%] gap-1.5">
            <span className={`text-[16px] font-semibold ${themeStyles.main.textHeadingColor}`}>
              {selectedVehicleClass?.vehicleLabel}
            </span>

            <div className={`flex flex-col items-start gap-1.5 text-xs ${themeStyles.main.textSubHeadingColor}`}>
              {
                selectedVehicleClass?.features
                  ?.sort((a: any, b: any) => a?.order - b?.order)
                  ?.map((feature: any, indexFeat: number) => {
                    const iconData = iconValues?.find((icon) => icon?.value === feature?.icon);
                    return (
                      <div key={indexFeat} className={`flex items-center gap-1 text-xs ${themeStyles.topBar.tailwindTextColor}`}>
                        {
                          iconData && (
                            <span className={`material-symbols-outlined text-[16px]`}>{iconData?.icon}</span>
                          )
                        }
                        <span>{feature?.label}</span>
                      </div>
                    )
                  })
              }

            </div>
          </div>

          {/* Price */}
          <div className="flex flex-col gap-1.5 w-[25%]">
            {
              selectedVehicleClass?.recommended && (
                <div className="flex justify-end">
                  <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold bg-[#D9F4D4]  text-[#039855] border ${themeStyles.main.borderColor}`}>
                    Recommended
                  </span>
                </div>
              )
            }

            <div className="flex flex-col gap-1.5 text-left">
              <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                <span className="font-semibold">${parseInt(selectedVehicleClass?.dailyRate)?.toFixed(2)}</span>
                <span className={`text-sm font-normal ${themeStyles.main.textHeadingColor}`}>/Day</span>
              </p>

              <p className={`text-sm ${themeStyles.main.textHeadingColor}`}>
                <span className="font-semibold"> $
                  {Number(summaryData?.totalBasePriceBeforeDiscount)?.toFixed(2)}{" "}
                  total for {selectedVehicleClass?.days} Day{" "}
                  {selectedVehicleClass?.hours > 0 && " and " + selectedVehicleClass?.hours + " hours"}</span>
              </p>

              <p className={`text-xs font-normal ${themeStyles.main.textSubHeadingColor}`}>
                Excl. taxes & insurance(s)
              </p>

              <p className={`text-xs font-semibold ${themeStyles.main.textSubHeadingColor}`}>
                Vehicle Available: {selectedVehicleClass?.availableVehicles}
                (
                {
                  (
                    (parseFloat(selectedVehicleClass?.availableVehicles) * 100) /
                    parseFloat(selectedVehicleClass?.vehicleCount)
                  )?.toFixed(2)
                }
                %
                )
              </p>
            </div>
          </div>
        </div>

        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Customer Information
        </span>
        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-2">
          <div className="grid grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>First Name</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{firstName}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Email Address</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{emailAddress}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Street</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{Street}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>City</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{city}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Zip</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{zip}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Birthday</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{birthday}</span>
              </div>

            </div>
            <div className="space-y-4">
              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Last Name</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{lastName}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Phone Number</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{phoneNumber}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Street 2</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{street2}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>State</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{state}</span>
              </div>

              <div>
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Country</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{country}</span>
              </div>
            </div>

          </div>
        </div>
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Extra Information
        </span>
        <Divider className={`w-full ${themeStyles.divider.bg}`} />
        <div className="w-full my-2">

          <table className="min-w-full">
            <tbody className="text-left">
              <tr className={`border-b ${themeStyles.main.borderColor}`}>
                <th className={`w-[15%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Type</th>
                <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>ID Number</th>
                <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Issued On</th>
                <th className={`w-[20%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Exp. Date</th>
              </tr>

              {
                extraRow?.map((item: ExtraInformation, index: number) => {
                  return (
                    <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                      <td className="pr-[0.25rem] py-2 w-[15%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{
                          type?.find((value: any) => value.id === parseInt(item?.idTypeId))
                            ?.name
                        }</span>
                      </td>

                      <td className="px-[0.25rem] py-2 w-[25%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.idNumber}</span>
                      </td>

                      <td className="px-[0.25rem] py-2 w-[20%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{moment(item?.issueDate).format(dateFormat)}</span>
                      </td>

                      <td className="pl-[0.25rem] w-[20%]">
                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{moment(item?.exprationDate).format(dateFormat)}</span>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>

          {
            localAddress && (
              <div className="mt-2">
                <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Local Address</span><br />
                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{localAddress}</span>
              </div>
            )
          }
        </div>

        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Signatures
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-2">
          <div>
            {
              confirmSignatureURL
                ? (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <img src={`${baseURL}reservationFile/Get?name=${confirmSignatureURL?.fileName}`} alt="signature" className="h-[150px]" />
                  </div>
                ) : (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <SignatureCanvas
                      ref={signaturePadRef}
                      penColor="#167AC3"
                      canvasProps={{
                        className: "w-full h-[150px]",
                      }}
                    />
                  </div>
                )
            }

            <i
              className="bx bxs-eraser text-white bg-orange-500 text-[18px] px-[5px] py-[3px] rounded cursor-pointer mt-[5px]"
              onClick={() => {
                if (!isCompletedOrCancelled) {
                  signaturePadRef.current?.clear();
                  if (confirmSignatureURL) {
                    deleteTheSignatureURL();
                  }
                }
              }}
            ></i>
          </div>
        </div>

        <div className="w-full flex gap-2.5 items-center mt-6">
          {
            (reservationId <= 0)
            && (
              <>
                <Button variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.main.bg,
                    fontSize: "10px"
                  }}
                  onClick={() => confirmTheReservation("Open")}
                >
                  Confirm Reservation
                </Button>

                <Button variant="contained"
                  sx={{
                    backgroundColor: colorConfigs.btn.cancel.bg,
                    border: colorConfigs.btn.cancel.border,
                    color: colorConfigs.btn.cancel.color,
                    fontSize: "10px"
                  }}
                  onClick={() => confirmTheReservation("Pending")}
                >
                  Confirm as Pending
                </Button>
              </>
            )
          }
        </div>
      </div>
    </>
  )
}